/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Scope_Connections_TitleInputs */



/**
* | output |
* | --- |
* | "Which connections may it use?" |
*
* @param {Agent_Scope_Connections_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_scope_connections_title = /** @type {((inputs?: Agent_Scope_Connections_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Scope_Connections_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Welche Verbindungen darf er nutzen?")
	return /** @type {LocalizedString} */ ("Which connections may it use?")
});